import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import { HOME_COURSE_CATEGORY , SEARCH_DOWNLOADAPP , SEARCH_POSTTEACHER,SEARCH_SPECIALITY,WHY_HOW_STUDENT_APP_TEXT, WHY_STUDENT_APP_TEXT1,WHY_STUDENT_APP_TEXT2,WHY_STUDENT_APP_TEXT3,WHY_STUDENT_APP_TEXT4,
  WHY_STUDENT_APP_TEXT5,WHY_STUDENT_APP_TEXT6,WHY_STUDENT_APP_TEXT7,WHY_STUDENT_APP_TEXT8,WHY_STUDENT_APP_TEXT9,WHY_STUDENT_APP_TEXT10,
  LOGIN_APPLE_STORE_LINK , LOGIN_PLAYSTORE_LINK,HOW_IT_WORKS_STEP1,HOW_IT_WORKS_STEP2,HOW_IT_WORKS_STEP3,HOW_IT_WORKS_STEP4,
  } from 'src/app/constants';
import {SEARCH_TITLE,SEARCH_KEYWORDS,SEARCH_KEYWORD_CONTENT,SEARCH_KEYWORD_DESC,SEARCH_KEYWORD_DESC_CONTENT} from  'src/app/seoconstants';



import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  state: any;
  newState: any;
  preState: any;
  checkState = false;

  state1: any;
  newState1: any;
  preState1: any;
  checkState1 = false;



  options = [
    {name:'dormant'}, 
    {name:'active'}, 
    {name:'finished'}
  ];

  options1 = [
    {name:'dormant'}, 
    {name:'active'}, 
    {name:'finished'}
  ];

  setState(state: any) {
    this.preState = this.newState;
    this.newState = state
    this.checkState = true;
  }
  setState1(state1: any){
    this.preState1 = this.newState1;
    this.newState1 = state1
    this.checkState1 = true;

  }

  selectedOption(option: any) {
    return this.newState === option;
  }

  selectedOption1(option1: any) {
    return this.newState1 === option1;
  }

  yes() {
    this.state = this.newState;
    this.checkState = false;
  }

  no() {
    this.checkState = false;
    this.newState = this.preState;

    this.checkState1 = false;
    this.newState1 = this.preState1;
  }
  no1() {
    this.checkState1 = false;
    this.newState1 = this.preState1;
  }
  
  serviceTypeList = [];
  speciallityList = [];
  category:string;
  specialityId:string;
  mode:string;
  specData:any;
  specialities:[];
  text1:string;
  text2:string;
  text3:string;
  text4:string;
  whyhowstudentapp:string;
  whystudentapp1:string;
  whystudentapp2:string;
  whystudentapp3:string;
  whystudentapp4:string;
  whystudentapp5:string;
  whystudentapp6:string;
  whystudentapp7:string;
  whystudentapp8:string;
  whystudentapp9:string;
  whystudentapp10:string;
  step1text:string;
  step2text:string;
  step3text:string;
  step4text:string;
  appleLink:string;
  playstoreLink:string;
  title:string;
  keywords:string;
  keywordcontent:string;
  desc:string;
  desccontent:string;
  

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService:HelperService,
    private titleService: Title, private metaService: Meta
    ) { }

  ngOnInit() {

    this.title = SEARCH_TITLE;
    this.keywords = SEARCH_KEYWORDS;
    this.keywordcontent = SEARCH_KEYWORD_CONTENT;
    this.desc = SEARCH_KEYWORD_DESC;
    this.desccontent = SEARCH_KEYWORD_DESC_CONTENT;


    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {name: this.keywords, content: this.keywordcontent},
      {name: this.desc, content: this.desccontent},
      {name: 'robots', content: 'index, follow'}
    ]);
    
    
    this.text1 = HOME_COURSE_CATEGORY;
    this.text2 = SEARCH_DOWNLOADAPP;
    this.text3 = SEARCH_POSTTEACHER;
    this.text4 = SEARCH_SPECIALITY;
    this.whyhowstudentapp = WHY_HOW_STUDENT_APP_TEXT;
    this.whystudentapp1 = WHY_STUDENT_APP_TEXT1;
    this.whystudentapp2 = WHY_STUDENT_APP_TEXT2;
    this.whystudentapp3 = WHY_STUDENT_APP_TEXT3;
    this.whystudentapp4 = WHY_STUDENT_APP_TEXT4;
    this.whystudentapp5 = WHY_STUDENT_APP_TEXT5;
    this.whystudentapp6 = WHY_STUDENT_APP_TEXT6;
    this.whystudentapp7 = WHY_STUDENT_APP_TEXT7;
    this.whystudentapp8 = WHY_STUDENT_APP_TEXT8;
    this.whystudentapp9 = WHY_STUDENT_APP_TEXT9;
    this.whystudentapp10 = WHY_STUDENT_APP_TEXT10;
    this.step1text=HOW_IT_WORKS_STEP1;
    this.step2text = HOW_IT_WORKS_STEP2;
    this.step3text = HOW_IT_WORKS_STEP3;
    this.step4text = HOW_IT_WORKS_STEP4;
    this.appleLink = LOGIN_APPLE_STORE_LINK;
    this.playstoreLink = LOGIN_PLAYSTORE_LINK;
   
    let vendata = {
      
    }

    this.apiService.getVenDetails(vendata).subscribe((res:any)=>{
      
      this.serviceTypeList = res.data.venDetails.data;  

    });

    let catspectdata = {
     
    }

    this.apiService.getSpecialityCategory(catspectdata).subscribe((result:any)=>{      
      this.specData = result;
      this.specData.forEach((element) => {        
        this.specialities = element.specialities;
      });
      

    })
    
  }

  speciallity(){
    
    this.specialityId = "undefined";
   
   let specialData = {
    
    vendorType:this.category
   }
    this.apiService.getspetialityDetails(specialData).subscribe((res:any)=>{
      
      this.speciallityList= res.data.venSplDetails.data;
                 
      this.speciallityList.forEach(function (value, key) {
       
      })

    });

    
  }

  
  clickme(){
    this.router.navigateByUrl(`about`);
  }
  searchResults(){    
   if(this.category==undefined){     
     alert("Please Select Category");
     return;
   }
   else {
    this.router.navigateByUrl(`searchResults` + `/` + this.category + `/` + this.specialityId + `/`+ this.mode );
   }
  }
  searchClasses(){  
    if(this.category==undefined)  {
      alert("Please Select Category");
     return;
    }   
   
    else {
    this.router.navigateByUrl(`search-class-results` + `/` + this.category + `/` + this.specialityId ,{ skipLocationChange: true });
 
  }
  }

  dashboard(){
    this.router.navigateByUrl(`dashboard`);
  }

  getSpecThumb(specId: string){
    return "https://s3.ap-south-1.amazonaws.com/dev.studented.in/category_speciality/images/" + specId + ".jpg";
  }

  viewAll(id){      
    //this.router.navigateByUrl(`search-class-results` + `/` + id + `/` + this.specialityId,{skipLocationChange: true}); 
    this.router.navigateByUrl(`search-class-results` + `/` + id + `/` + this.specialityId,{skipLocationChange: true});
  }
  view(id: string , id1: string){    
    //this.router.navigateByUrl(`search-class-results` + `/` + id + `/` + id1 + `/`+ this.mode);
    this.router.navigateByUrl(`search-class-results` + `/` + id + `/` + id1);
  }

  createPost(){
    this.router.navigateByUrl(`create-post`);
  }


  customOptions: OwlOptions = {
    loop: true,   
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 2000,   
    navText: ["<img src='assets/images/aro-fnt-blk.png'>", "<img src='assets/images/aro-bk-blk.png'>"],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 4
      },
      740: {
        items: 5
      },
      940: {
        items: 6
      }
    },
    nav: true
  }

  customOptionstwo: OwlOptions = {
    loop: true,   
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 3000,  
    navText: ["<img src='assets/images/aro-bk-blk.png'>", "<img src='assets/images/aro-fnt-blk.png'>"],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 4
      },
      940: {
        items: 4
      }
    },
    nav: true
  }

}
